import { connect } from 'react-redux'
import moment from 'moment'
import at from 'lodash/at'

import Reports from '../../components/reports/reports'

import { loadReports, downloadReport, deleteReport } from '../../actions/reports'

function mapStateToProps (state, ownProps) {
  const reports = at(state.reports, state.pagination.reports.ids || [])
  return {
    reports,
    hasNextPage: !!state.pagination.reports.nextPageUrl
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  dispatch(loadReports())

  return {
    downloadReport(reportId) {
      dispatch(downloadReport(reportId))
        .then(() => dispatch(loadReports()))
    },

    deleteReport(reportId) {
      dispatch(deleteReport(reportId))
        .then(() => dispatch(loadReports()))
    },

    onLoadNextPage () {
      dispatch(loadReports(true))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Reports)



// WEBPACK FOOTER //
// ./src/containers/reports/reports-container.js